import condriLogo from "@/assets/condri-without-background.png"
import { Shield } from "lucide-react"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useCurrentUser } from "@/hooks/useCurrentUser"
import { MagicLinkForm } from "@/components/auth/MagicLinkForm"

const StaffLoginPage = () => {
  const { data: user } = useCurrentUser()
  const navigate = useNavigate()

  // Check if user is already logged in and is staff/admin
  useEffect(() => {
    if (user) {
      const isStaff =
        user.is_staff ||
        user.is_superuser ||
        user.role_list?.includes("admin") ||
        false

      if (isStaff) {
        // Already logged in as staff, redirect to admin
        navigate("/admin", { replace: true })
      }
    }
  }, [user, navigate])

  return (
    <div className="min-h-screen max-w-md mx-auto bg-card flex flex-col">
      <div className="flex-1 flex flex-col justify-center px-6 pt-8">
        <div className="text-center space-y-6">
          <div className="mx-auto w-20 h-20 bg-primary-faded rounded-full flex items-center justify-center p-2">
            <img
              src={condriLogo}
              alt="Condri Logo"
              className="w-full h-full object-contain"
            />
          </div>

          <div className="space-y-3">
            <div className="flex items-center justify-center gap-2">
              <Shield className="w-6 h-6 text-primary" />
              <h1 className="text-3xl font-bold text-foreground">
                Staff Login
              </h1>
            </div>
            <p className="text-muted-foreground text-lg">
              Staff members only. Regular users should use the mobile app.
            </p>
          </div>
        </div>
      </div>

      <div className="flex flex-1 flex-col px-6 pb-6 space-y-6">
        <MagicLinkForm allowedEmailDomain="condri.app" />
      </div>
    </div>
  )
}

export default StaffLoginPage
